export class BilEventSnackbarClose  {
  constructor() {
  }
  public static EventSelector(eventInfo: any): boolean {
    return eventInfo instanceof BilEventSnackbarClose;
  }
}
